import { render, staticRenderFns } from "./PermissionSet.vue?vue&type=template&id=63d908b8&scoped=true&"
import script from "./PermissionSet.vue?vue&type=script&lang=js&"
export * from "./PermissionSet.vue?vue&type=script&lang=js&"
import style0 from "./PermissionSet.vue?vue&type=style&index=0&id=63d908b8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d908b8",
  null
  
)

export default component.exports